module.exports = __webpack_public_path__ + "static/media/used19.a10f8447.JPG";